import { JoinProvider } from "components/context/joinContext";
import JoinLayout from "./layout";

export default function Join() {
  return (
    <JoinProvider>
      <JoinLayout />
    </JoinProvider>
  );
}
